<script setup lang="ts">
import type { Blocks, Metadata } from 'types/index';
import type { NewsDetailPageContentResponse } from '~/types/news';

const props = defineProps<{
  blocks: Blocks;
  content: NewsDetailPageContentResponse;
  metadata: Metadata;
}>();

const computedBlocks = computed(() => {
  return props.blocks.blocks || {};
});
</script>

<template>
  <main>
    <BaseComponentWrapper class="no-margin-top no-margin-bottom bg-gray-10">
      <div class="container">
        <PartialsNewsPaginatedList />
        <BlockList
          v-if="computedBlocks"
          :blocks="computedBlocks"
        />
      </div>
    </BaseComponentWrapper>
  </main>
</template>
